import React from "react";

interface Props {
	className?: string;
	size?: number;
	color?: string;
}

export const IconNewWindowLg: React.FC<Props> = ({
	className = "",
	size = 17,
	color = "currentColor",
}) => {
	return (
		<svg
			width={size}
			height={size * (19 / 17)}
			viewBox="0 0 17 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M9.75 4.42859H2.875C2.37772 4.42859 1.90081 4.62613 1.54917 4.97776C1.19754 5.32939 1 5.80631 1 6.30359V15.0536C1 15.5509 1.19754 16.0278 1.54917 16.3794C1.90081 16.731 2.37772 16.9286 2.875 16.9286H11.625C12.1223 16.9286 12.5992 16.731 12.9508 16.3794C13.3025 16.0278 13.5 15.5509 13.5 15.0536V8.17859M4.75 13.1786L16 1.92859M16 1.92859H11.625M16 1.92859V6.30359"
				stroke={color}
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};
